import type { GivingDetail } from 'models';
import { useMemo } from 'react';
import { Card, Col, ProgressWithMilestones, Row, Text, Title, useFormatPrice } from 'ui';

type P = {
  giving: GivingDetail;
};

const ProgressCard = ({ giving }: P) => {
  const formatPrice = useFormatPrice();
  const percent = useMemo(() => (giving.amountGoal ? (giving.amountTotal / giving.amountGoal) * 100 : 0), [giving]);

  if (!giving.amountGoal) {
    return;
  }

  return (
    <Card className="giving-detail-progress-card">
      <Row gutter={['ms', 0]}>
        <Col>
          <Title level={4} type="success">
            {formatPrice({ value: giving.amountTotal })}
          </Title>
          <Text>raised</Text>
        </Col>
        <Col flex="auto">
          <ProgressWithMilestones percent={percent} size="extra-small" />
        </Col>
        <Col textAlign="end">
          <Title level={4}>{formatPrice({ value: giving.amountGoal })}</Title>
          <Text>goal</Text>
        </Col>
      </Row>
    </Card>
  );
};

export default ProgressCard;
